module.exports = __webpack_public_path__ + "1b70c3069db5d0d80e8b242a32f378d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/wasistgoldencity2.jpg
// module id = 913
// module chunks = 0